import React, { Component } from 'react';
import { Button, Popup } from 'semantic-ui-react';
import ReactTable from 'react-table';
import { FixedSizeList } from 'react-window';
import scroll from 'helpers/scroll';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

const ROW_HEIGHT = 49;

const propTypes = {};

const defaultProps = {};
class StepThreeStaff extends Component {
  constructor(props) {
    super(props);
    // 현재 화면에 보이는 항목 인덱스 범위
    this.visibleRange = { start: 0, stop: 0 };
    this.state = {
      containerHeight: 550,
      headers: [
        { header: 'ID', width: 120, style: { textAlign: 'right' }, isChecked: false },
        { header: '이름', width: 120 },
        {
          header: '잔여 식대',
          width: 120,
          style: { textAlign: 'right' },
          headerStyle: { textAlign: 'right' }
        }
      ]
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const jsStaffListChange = JSON.stringify(this.props.policyStaffList) !== JSON.stringify(nextProps.policyStaffList);
    const staffListChange = this.props.policyStaffList !== nextProps.policyStaffList;

    return !staffListChange || jsStaffListChange;
  }

  listItem = (item, style) => {
    const { headers } = this.state;
    const { fn, data } = this.props;
    let result = null;

    if (item) {
      let policyAmount = 0;
      item.policy.some((data) => {
        if (data.idx === item.sPolicy) {
          policyAmount = cm.numberComma(data.amount);
        }
      });

      const params = {
        id: item.id,
        type: 'oneByone'
      };

      const moneyInputBox = (
        <div>
          <input
            // placeholder={0}
            min={0}
            style={data.topMenu.tabType === 'deduct' ? { color: 'red', textAlign: 'right' } : { textAlign: 'right' }}
            // className={item.money ? "money " : "money value-null"}
            className={'money '}
            id={`money-${item.id}`}
            onKeyUp={(e) => this.keyCheck(e)}
            onChange={(e) => fn.stepThreeAllBtn(e, 'money', params)}
          />
        </div>
      );

      const reasonInputBox = (
        <div>
          <input
            placeholder="사유 최대 50자"
            // className={item.reason ? "" : "value-null"}
            className={''}
            // value={item.reason}
            id={`reason-${item.id}`}
            // maxLength={50}
            onChange={(e) => fn.stepThreeAllBtn(e, 'reason', params)}
          />
        </div>
      );

      const division = cm.trTdDivision(item.orgCode);
      let styles = [];
      headers.forEach((headerItem, index) => {
        styles.push({
          flex: `${headerItem.width} 0 auto`,
          width: headerItem.width,
          maxWidth: headerItem.width,
          padding: '10px 10px',
          textAlign: index === 2 ? 'right' : null
        });
      });

      result = (
        <div className="rt-tr -odd" key={item.id} style={{ ...style, display: 'flex', alignItems: 'center' }}>
          <div className="rt-td" style={styles[0]}>
            {item.signid}
          </div>
          <div className="rt-td" style={styles[1]}>
            {item.name}
          </div>
          {division.map((divi, i) => {
            return (
              <div
                key={`divi${i}`}
                className="rt-td"
                style={{ flex: `100 0 auto`, width: 128, maxWidth: 128, padding: '10px 0' }}
              >
                <Popup className="td-tooltip" inverted trigger={<span>{divi}</span>} content={divi} />
              </div>
            );
          })}
          <div className="rt-td" style={styles[2]}>
            {policyAmount}
          </div>
          <div className="rt-td" style={{ flex: '200 0 auto', width: 200, maxWidth: 200 }}>
            {moneyInputBox}
          </div>
          <div className="rt-td" style={{ flex: '550 0 auto', width: 550, maxWidth: 550 }}>
            {reasonInputBox}
          </div>
        </div>
      );

      return result;
    } else {
      return null;
    }
  };

  renderRow = ({ index, style }) => {
    const { policyStaffList } = this.props;
    return this.listItem(policyStaffList[index], style);
  };

  handleItemsRendered = ({ visibleStartIndex, visibleStopIndex }) => {
    this.visibleRange = { start: visibleStartIndex, stop: visibleStopIndex };
    this.scrollHandler(visibleStartIndex, visibleStopIndex);
  };

  scrollHandler = (start, stop) => {
    const { policyStaffList, data } = this.props;
    for (let i = start; i <= stop; i++) {
      const item = policyStaffList[i];
      if (!item) continue;
      $(`#money-${item.id}`).prop('value', item['money']);
      $(`#reason-${item.id}`).prop('value', item['reason']);
      if (data.inputCheck) {
        if (!item.money && item.money !== 0) {
          $(`#money-${item.id}`).addClass('value-null');
        } else {
          $(`#money-${item.id}`).removeClass('value-null');
        }
        if (!item.reason) {
          $(`#reason-${item.id}`).addClass('value-null');
        } else {
          $(`#reason-${item.id}`).removeClass('value-null');
        }
      }
    }
  };

  tBodyFunc = (state) => {
    const { policyStaffList } = this.props;
    const { containerHeight } = this.state;
    return (
      <div className="rt-tbody scroll-rt-body" style={state.style}>
        <div className="rt-tr-group">
          <FixedSizeList
            height={containerHeight}
            itemCount={policyStaffList ? policyStaffList.length : 0}
            itemSize={ROW_HEIGHT}
            width="100%"
            style={{ overflowX: 'hidden' }}
            onItemsRendered={this.handleItemsRendered}
          >
            {this.renderRow}
          </FixedSizeList>
        </div>
      </div>
    );
  };

  noDataProps = () => {
    const { policyStaffList } = this.props;
    let dom = <div className="rt-noData">검색 결과가 없습니다.</div>;
    if (policyStaffList.length > 0) {
      dom = <div className="rt-noData"></div>;
    }

    return dom;
  };

  keyCheck = (e) => {
    let money = $(e.target).val();
    money = cm.numberComma(cm.toInt(money));
    $(e.target).val(money);
  };

  textlengthCheck = (e) => {
    if (e.target.value.length > 50) {
      toastr('top-right', 'warning', '50자 이하로 입력해주세요.');
      e.target.value = e.target.value.substring(0, 50);
      return;
    }
  };

  componentDidUpdate() {
    const { start, stop } = this.visibleRange;
    this.scrollHandler(start, stop);
  }

  render() {
    const { data, fn, policyStaffList } = this.props;
    const { headers } = this.state;

    const params = {
      gIdx: policyStaffList && policyStaffList.length > 0 ? policyStaffList[0].group.idx : null,
      pIdx: policyStaffList && policyStaffList.length > 0 ? policyStaffList[0].sPolicy : null
    };
    let moneyplaceholder = data.topMenu.tabType === 'give' ? '지급 식대' : '차감 식대';
    const moneyInputBox = (
      <div>
        <input
          style={{ textAlign: 'right', marginRight: '4px' }}
          placeholder={moneyplaceholder}
          min={0}
          onKeyUp={(e) => this.keyCheck(e)}
          id="allMoney"
        />
        <Button inverted color="black" onClick={(e) => fn.stepThreeAllBtn(e, 'money', params)}>
          모두적용
        </Button>
      </div>
    );

    const reasonInputBox = (
      <div>
        <input
          style={{ marginRight: '4px' }}
          id="allReason"
          placeholder="사유 최대 50자"
          onChange={(e) => this.textlengthCheck(e)}
        />
        <Button inverted color="black" onClick={(e) => fn.stepThreeAllBtn(e, 'reason', params)}>
          모두적용
        </Button>
      </div>
    );

    let header = cm.tableHeaderList(headers, 2);
    header.push({ header: moneyInputBox, width: 200, headerClassName: 'header-input-box' });
    header.push({ header: reasonInputBox, width: 550, headerClassName: 'header-input-box' });
    const fnuc = { fnChecked: null, move: null };
    const columns = scroll.header(header, fnuc);

    return (
      <div>
        <ReactTable
          className="react-table"
          noDataText="검색 결과가 없습니다."
          columns={columns}
          sortable={false}
          resizable={false}
          showPagination={false}
          TbodyComponent={this.tBodyFunc}
          NoDataComponent={this.noDataProps}
        />
      </div>
    );
  }
}

StepThreeStaff.propTypes = propTypes;
StepThreeStaff.defaultProps = defaultProps;

export default StepThreeStaff;
